"use client";

import { Menu } from "lucide-react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Sheet, SheetClose, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { PhoneLink } from "@/components/public/analytics/phone-link";
import type { ResolvedNavItem } from "@/lib/navigation/resolve";

interface MobileNavProps {
  items: ResolvedNavItem[];
  phone?: string;
}

export function MobileNav({ items, phone }: MobileNavProps) {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Open menu" className="flex md:hidden">
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="flex flex-col gap-6 pt-12">
        <SheetTitle className="sr-only">Navigation menu</SheetTitle>
        <nav className="flex flex-col gap-4">
          {items.map((item) => (
            // SheetClose dismisses the drawer on tap, so a client-side (soft)
            // navigation doesn't leave the drawer mounted over the destination.
            <SheetClose asChild key={item.href}>
              <Link
                href={item.href}
                className="text-base font-medium transition-colors hover:text-(--color-brand-accent)"
              >
                {item.label}
              </Link>
            </SheetClose>
          ))}
        </nav>
        {phone ? (
          <PhoneLink phone={phone} className="mt-auto font-semibold text-(--color-brand-accent)" />
        ) : null}
      </SheetContent>
    </Sheet>
  );
}
